export default class Position {
  constructor(x, y, entity = null, timestamp = Date.now()) {
    this.x = x;
    this.y = y;
    this.entity = entity;
    this.timestamp = timestamp;
  }

  getEntity() {
    if (!this.entity) {
      console.error('ERROR: Entity was never assigned to this position')
      return false;
    }
    return this.entity;
  }
}